import { Component } from '@angular/core';
import { ORCIDAddressEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Addresses') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidaddress-form',
    templateUrl: './orcidaddress.form.component.html'
})
export class ORCIDAddressFormComponent extends BaseFormComponent {
    public record!: ORCIDAddressEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

